import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

const SubmitButton = (props) => {
    return (
        <Button
            disabled={props.submitting}
            onClick={props.onSubmit}
            type="submit"
        >
            {props.submitting ? <CircularProgress size={20}/> : null}
            <FormattedMessage id={props.submitting ? "buttons.submitting" : "buttons.submit"}/>
        </Button>
    );
};

SubmitButton.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool
};

export default SubmitButton;


// WEBPACK FOOTER //
// ./src/components/common/button/SubmitButton.js